import type React from 'react';

import type { IconProps } from '../types';

export const ArrowRightXs: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.0033 2.69121C8.29268 2.43229 8.72738 2.43891 9.00818 2.69512L13.3119 7.49981C13.5626 7.78005 13.5627 8.21949 13.3119 8.49981L9.06189 13.2498C8.78568 13.5584 8.31194 13.5846 8.00329 13.3084C7.69471 13.0322 7.66854 12.5585 7.9447 12.2498L11.0756 8.74981L3.2533 8.74981C2.83908 8.74981 2.5033 8.41402 2.5033 7.99981C2.5033 7.5856 2.83908 7.24981 3.2533 7.24981L11.0756 7.24981L7.89587 3.69024C7.67242 3.38283 7.71403 2.95014 8.0033 2.69121Z"
      fill={color}
    />
  </svg>
);
